import React from 'react';
import LegalLayout from './LegalLayout';

const H2 = ({ children }) => (
  <h2 className="font-serif text-ivory text-2xl md:text-3xl leading-tight mt-12 mb-4">
    {children}
  </h2>
);

const TermsOfService = () => (
  <LegalLayout
    eyebrow="Terms of Service"
    title="The fine print, gracefully."
    lastUpdated="May 12, 2026"
  >
    <p>
      Welcome to Snatched Beauties Privé. By accessing our website, booking a service,
      or enrolling in a wellness program, you agree to these Terms of Service. Please
      read them carefully.
    </p>

    <H2>1. Services Offered</H2>
    <p>
      Snatched Beauties Privé offers non-invasive body sculpting, lymphatic and recovery
      rituals, skin treatments, and peptide wellness programs. All services are provided
      by trained professionals at our Los Angeles studio.
    </p>

    <H2>2. Bookings &amp; Consultations</H2>
    <p>
      Appointments are scheduled through our online booking system (Calendly) or by
      phone. A consultation is required before certain treatments, including all
      peptide programs and any treatment marked "Consultation Required."
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>You must be 18 years or older to book any service.</li>
      <li>You agree to provide accurate health information during consultation.</li>
      <li>We reserve the right to decline service if a treatment is not appropriate
        for your health profile.</li>
    </ul>

    <H2>3. Payment &amp; Pricing</H2>
    <p>
      Payments are processed securely through Stripe. Prices are listed on the website
      and may be updated periodically. Service-card pricing reflects per-session rates
      unless otherwise indicated.
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>Peptide programs are billed monthly via recurring subscription.</li>
      <li>Discount coupons (e.g., 15% welcome offer) are valid for 30 days from
        issuance, single-use, and non-transferable.</li>
      <li>Bespoke packages and Atelier-tier services are quoted individually.</li>
    </ul>

    <H2>4. Cancellation &amp; Refund Policy</H2>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        <strong className="text-ivory">Appointments</strong>: We require 24-hour notice
        for cancellation or rescheduling. Late cancellations may be subject to a fee
        equivalent to 50% of the booked service.
      </li>
      <li>
        <strong className="text-ivory">No-shows</strong>: Missed appointments without
        notice may be charged the full service amount.
      </li>
      <li>
        <strong className="text-ivory">Programs &amp; subscriptions</strong>: Monthly
        programs may be canceled with 30 days' notice. Unused services within the
        current billing month do not roll over unless explicitly stated.
      </li>
      <li>
        <strong className="text-ivory">Refunds</strong>: Treatments are non-refundable
        once performed. If a service cannot be delivered due to studio error, you may
        request a refund or credit within 14 days.
      </li>
    </ul>

    <H2>5. Health &amp; Safety Disclaimer</H2>
    <p>
      All services are wellness, cosmetic, and aesthetic in nature.{' '}
      <strong className="text-ivory">
        Our treatments are not intended to diagnose, treat, cure, or prevent any
        disease.
      </strong>{' '}
      We do not provide medical advice. Always consult your physician before beginning
      any new wellness program, especially if you are pregnant, nursing, have a chronic
      medical condition, or are taking medication.
    </p>
    <p>
      Peptide programs require a personalized health assessment. Administration is
      performed only after a qualified consultation and your informed consent.
    </p>

    <H2>6. Results Disclaimer</H2>
    <p>
      Individual results vary. Before-and-after photos and testimonials reflect
      individual experiences and are not a guarantee of any specific outcome. Multiple
      sessions, consistent attendance, and complementary lifestyle factors (nutrition,
      hydration, sleep) significantly influence results.
    </p>

    <H2>7. Intellectual Property</H2>
    <p>
      All content on this website — including photography, copy, treatment names,
      brand elements, and visual identity — is the property of Snatched Beauties Privé.
      Unauthorized use, reproduction, or distribution is prohibited.
    </p>

    <H2>8. Limitation of Liability</H2>
    <p>
      To the maximum extent permitted by law, Snatched Beauties Privé shall not be
      liable for any indirect, incidental, or consequential damages arising from your
      use of our services or website. Total liability for any claim is limited to the
      amount you paid for the specific service in question.
    </p>

    <H2>9. Privacy</H2>
    <p>
      Your personal data is handled in accordance with our{' '}
      <a href="/privacy" className="text-blush hover:underline">Privacy Policy</a>,
      incorporated here by reference.
    </p>

    <H2>10. Changes to Terms</H2>
    <p>
      We may revise these Terms from time to time. The "Last Updated" date reflects
      the most recent revision. Continued use of our services after changes constitutes
      acceptance.
    </p>

    <H2>11. Governing Law</H2>
    <p>
      These Terms are governed by the laws of the State of California, United States.
      Any disputes shall be resolved in the state or federal courts located in Los
      Angeles County.
    </p>

    <H2>12. Contact</H2>
    <p>
      Snatched Beauties Privé<br />
      Los Angeles, California<br />
      Email:{' '}
      <a href="mailto:support@snatchedbeauties.com" className="text-blush hover:underline">
        support@snatchedbeauties.com
      </a>
      <br />
      Phone:{' '}
      <a href="tel:3236135153" className="text-blush hover:underline">323-613-5153</a>
    </p>
  </LegalLayout>
);

export default TermsOfService;
